module.exports = __webpack_public_path__ + "static/media/1-5.ff156ca8.mp3";